module.exports = __webpack_public_path__ + "be641d7847324ae51b8d06ca21d5dc9e.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-HeavyItalic.ttf
// module id = 975
// module chunks = 0